<template>
    <div class="home2">
      <el-container>
        <el-header>
          <div class="iconbox">
            <div @click="back"><i class="el-icon-s-home"></i>返回</div>
            <!-- <img src="@/imgs/HJicon.png" alt="" class="HJicon" @click="back" /> -->
            长三角农田土壤污染分布与健康风险评估后台管理
          </div>
          <el-dropdown placement="bottom" @command="handleCommand">
            <span class="el-dropdown-link">
              <div class="user">
                <i class="el-icon-user-solid"></i>{{ username }}
              </div>
            </span>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="logout"><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>
        <el-container>
          <el-aside width="200px">
            <ul>
              <li
                v-for="item in list"
                :key="item.id"
                @click="routerto(item)"
                :class="item.id == currentindex ? 'active' : ''"
              >
                <i :class="item.icon"></i>
                {{ item.name }}
              </li>
            </ul>
          </el-aside>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </template>
  <script>

  export default {
    data() {
      return {
        // token: Cookie.get("token"),
        // id: Cookie.get("id"),
        currentindex: 1,
        username: this.$Cookie.get("username"),
        list: [
          {
            id: 1,
            name: "数据管理",
            router: "/backGround/datagl",
            icon: "el-icon-s-data",
          },
          {
            id: 2,
            name: "账号管理",
            router: "/backGround/usergl",
            icon: "el-icon-s-custom",
          },

        ],
      };
    },
    methods: {
      routerto(item) {
        this.$router.push(item.router);
        this.currentindex = item.id
      },
 
      handleCommand(command) {
        if (command === "logout") {
            this.$router.push("/Login")
            this.$message({
            message: '已退出',
            type: 'success'
            });
        }
      },
      back(){
        this.$router.push("/HomeView")
      }
          //   logout() {
    //     this.$confirm("将退出登录, 是否继续?", "提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     })
    //       .then(() => {
    //         this.$message({
    //           type: "success",
    //           message: "成功退出!",
    //         });
    //         Cookie.remove("token");
    //         Cookie.remove("id");
    //         localStorage.removeItem('username')
    //         this.$router.push("/Login");
    //       })
    //       .catch(() => {
    //         this.$message({
    //           type: "info",
    //           message: "取消退出",
    //         });
    //       });
    //   },
    },
    computed: {
     
    },
    mounted() {

    },
  };
  </script>
  <style lang="scss" scoped>
  .home2 {
    .el-header {
      height: 64px;
    //   background-color: rgba(246, 246, 246, 1);
      padding-left: 15px;
      border-bottom: 1px solid rgba(246, 246, 246, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 3px 6px 1px rgba(0, 96, 156, 0.1);
      margin-bottom: 4px;
      color: #000;
      .iconbox {
        display: flex;
        align-items: center;
        color: rgba(1, 5, 62, 1);
        font-size: 18px;
        div{
            margin-right: 12px;
            color: rgb(14, 29, 201);
            cursor: pointer;
        }
      }
      .HJicon {
        cursor: pointer;
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      .user {
        margin-right: 70px;
        color: rgba(1, 5, 62, 1);
        font-size: 20px;
        cursor: pointer;
        i {
          margin-right: 10px;
        }
      }
    }
    .el-aside {
        // background-color: rgba(246, 246, 246, 1);
      border-right: 1px solid rgba(0, 32, 55, 0.2);
      height: calc(100vh - 64px);
      width: 200px !important;
      color: #000;
      ul {
        li {
          line-height: 64px;
          cursor: pointer;
          padding-left: 24px;
          font-weight: Medium;
          font-size: 20px;
        }
        .active {
          color: rgba(47, 84, 235, 1);
          border-right: 4px solid rgba(47, 84, 235, 1);
        }
      }
    }
    .el-main {
      background-color: rgba(246, 246, 246, 1);
      padding: 12px;
    }
  }
  .el-dropdown-menu__item {
    line-height: 36px !important;
    right: 60px;
  }
  
  .el-dropdown-menu {
    margin-right: 60px;
  }
  </style>
  